import React, { Fragment } from "react";
import { Dialog as MUIDialog, Grid, Typography, Button } from "@mui/material";

export default function RedirectDialog({ popUp, redirectURL, setPopUp }) {
  const handleClose = () => {
    setPopUp(false);
  };

  return (
    <Fragment>
      <MUIDialog
        open={popUp}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: "800px",
            borderRadius: "12px",
          },
        }}
      >
        <Grid container sx={{ p: 5 }} spacing={3} alignItems="center">
          <Grid size={12} md={9}>
            <Typography variant="h5">
              Start WhatsApp Onboarding Journey by clicking the button
            </Typography>
          </Grid>

          <Grid size={12} md={3}>
            <Button
              variant="contained"
              href={redirectURL}
              target="_blank"
              fullWidth
            >
              Go To Onboarding Page
            </Button>
          </Grid>
        </Grid>
      </MUIDialog>
    </Fragment>
  );
}
